import * as React from 'react';
import { useTheme } from '../../../theme';
import { Grid } from '@mui/material';
import { Field, useForm } from 'react-final-form';
import { TravellerFields } from '../../types';
import Input from '../../../BaseComponents/Input';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_MIN_WIDTH } from '../../../utils';
import { InputVariant } from '../../../BaseComponents/Input/types';
import { useTranslation } from 'react-i18next';
import SexSelector from '../../../BaseComponents/SexSelector';
import { DateMaskedInput } from '../../../DateMaskedInput/DateMaskedInput';

const PersonalInfoSection: React.FC = () => {
	const { PersonalInfoSection: css } = useTheme('TravellerForm');

	const { t: tDocumentCardForm } = useTranslation('DocumentCardForm');
	const { t: tTraveller } = useTranslation('Traveller');

	const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });

	const variant: InputVariant = isMobile ? 'underline' : 'labelIn';

	const form = useForm();

	return (
		<div className={css.personalInfoSection}>
			<Grid container spacing={2} sx={{ flex: 1, minWidth: 0 }}>
				<Grid size={{ xs: 8, sm: 4 }}>
					<Field
						name={TravellerFields.BirthDate}
						render={({ input, meta }) => (
							<Input
								{...input}
								className={css.input}
								variant={variant}
								label={`${tTraveller('birthDate')}*`}
								error={meta.error && meta.touched}
								helperText={meta.touched && tDocumentCardForm(meta.error)}
								InputProps={{
									inputComponent: DateMaskedInput
								}}
								onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
									input.onChange(event);
									form.mutators.fixEmptyFieldMutator({ fieldName: TravellerFields.BirthDate });
								}}
							/>
						)}
					/>
				</Grid>

				<Grid size={{ xs: 4, sm: 4 }}>
					<Field
						name={TravellerFields.Gender}
						render={({ input, meta }) => (
							<SexSelector
								activeSex={input.value}
								onChange={input.onChange}
								error={meta.error && meta.touched}
								helperText={meta.touched && tDocumentCardForm(meta.error)}
							/>
						)}
					/>
				</Grid>
			</Grid>
		</div>
	);
};

export default PersonalInfoSection;
